import React from "react";
import { useIntl } from "react-intl";
import { Select } from "../../../_metronic/_partials/controls";

export const ObjectGenderTitles = [
  "MODULES.BASEINFO.USERS.GENDER_MALE",
  "MODULES.BASEINFO.USERS.GENDER_FEMALE",
];

export const SelectGender = (props) => {
  const intl = useIntl();
  const { field } = props;
  const defaultValue = (gender) => {
    if (gender) {
      return gender === "MODULES.BASEINFO.USERS.GENDER_FEMALE" ? "2" : "1";
    } else return 1;
  };
  return (
    <>
      <Select
        name="gender"
        value={field.value === "Female" || field.value === "2" ? "2" : "1"}
        {...props}
      >
        {ObjectGenderTitles.map((gender, index) => (
          <option key={index} value={defaultValue(gender)}>
            {intl.formatMessage({ id: gender })}
            {/* {isDeleted} */}
          </option>
        ))}
      </Select>
    </>
  );
};
